export * from "./view-resolve-sdm-inner-ssr.component";
export * from "./view-resolve-sdm-inner.component";
